import { ClerkProvider, ClerkProviderProps } from "@clerk/react";
import { useTheme, config } from '@my/ui';

const colorPrimary = '#2BBF66';

export function AuthProvider({ children, publishableKey }: ClerkProviderProps) {
    const theme = useTheme();
    //console.log(theme.background)
    //@ts-ignore
    return <ClerkProvider
        publishableKey={publishableKey}
        appearance={{
            userButton: {
                variables: {
                    fontFamily: config.fonts.body.family,
                    colorPrimary,
                    colorAlphaShade: '#111',
                    colorTextOnPrimaryBackground: '#111',
                    colorText: '#010101'
                }
            },
            userProfile: {
                variables: {
                    fontFamily: config.fonts.body.family,
                    colorPrimary,
                    colorAlphaShade: '#111'
                }
            },
        }}
    >
        {children}
    </ClerkProvider>;
}